<template lang="pug" src="./modal-review.pug"></template>

<script>
import Icon from 'components/icon/icon'

export default {
  props: ['content'],
  data: () => {
    return {
      showReviewModal: false
    }
  },
  components: {
    Icon
  },
  created () {
    document.getElementsByTagName('body')[0].style.overflow = 'hidden'
  },
  beforeDestroy () {
    document.getElementsByTagName('body')[0].style.overflow = 'auto'
  }
}
</script>



// WEBPACK FOOTER //
// modal-review.vue?f289aa0a